export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8908.11433304.jpg";